import { memo } from 'react';

import PropTypes from 'prop-types';

import * as Styled from './SubscriptionAsset.style';

import getSharedAsset from '../utils/sharedAssetMap';

export const SubscriptionAsset = memo(function SubscriptionAsset({ service, included }) {
  if (included) {
    return null;
  }

  const assetUrl = getSharedAsset(service);

  return (
    <Styled.SubscriptionAssetContainer>
      <img src={assetUrl} alt={service} width={50} height={50} />
    </Styled.SubscriptionAssetContainer>
  );
});

SubscriptionAsset.propTypes = {
  service: PropTypes.string.isRequired,
  included: PropTypes.bool,
};
